import { defineStore } from 'pinia'
import { ref, computed } from "vue";

export const useFormModalControlsStore = defineStore('FormModalControls', () => {

    // State
    const formModalShow  = ref(false),
          formModalTitle = ref(null)

    // Getters
    const formModalVisible = computed(() => { return formModalShow.value })

    // Actions
    function formModalOpen() {
        setTimeout(() => {
            formModalShow.value = true
        }, 100)
    }

    function formModalClose() {
        formModalShow.value = false
        setTimeout(() => {
            if (formModalTitle.value) {
                formModalClearTitle()
            }
        }, 500)
    }

    function formModalSetTitle(title) {
        formModalTitle.value = title
    }

    function formModalClearTitle() {
        formModalTitle.value = null
    }

    return {
        formModalShow,
        formModalTitle,
        formModalVisible,
        formModalOpen,
        formModalClose,
        formModalSetTitle
    }
})
